@for (g of placeholder.galleries; track g) {
  <div class="iconGallery">
    <h2 class="iconGallery--section-title shimmer"></h2>
    <div class="iconGallery--icon-list">
      @for (i of placeholder.icons; track i) {
        <div class="iconGallery--icon">
          <span class="uilab-icon shimmer"></span>
        </div>
      }
    </div>
  </div>
}
